import HomepageHeroImage from '../static/images/assets/HomepageHero5.png';

const HomepageHero = () => {

  return (
    <div className="landing-hero-shell">
    {/* <!-- Hero --> */}
<div className="max-w-[85rem] mx-auto sm:px-6 px-4 lg:px-8">
  {/* <!-- Grid --> */}
  <div className="landing-hero-card relative grid overflow-hidden rounded-3xl bg-[#E4F2FE] px-6 py-10 md:grid-cols-2 md:items-center md:gap-8 sm:px-10 lg:px-12 lg:py-14">
    <span className="landing-hero-glow landing-hero-glow-one" aria-hidden="true" />
    <span className="landing-hero-glow landing-hero-glow-two" aria-hidden="true" />
    <div className='relative z-10 mt-4 text-center sm:text-left'>


<div> 
      <p className="landing-pill mx-auto mb-5 inline-flex rounded-full bg-white/80 px-4 py-2 text-sm font-semibold text-blue-700 shadow-sm ring-1 ring-blue-100 sm:mx-0">
        Messaging infrastructure for growing teams
      </p>
      <h1 className="landing-title block text-4xl font-black text-[#040051] lg:text-6xl lg:leading-tight dark:text-white mb-6 sm:mb-0" > The Pan-African Messaging <span className="text-blue-600">Platform</span></h1>

      </div>
      <p className="landing-copy mt-5 text-md sm:text-lg leading-8 text-[#4A487A] dark:text-gray-400"> We provide an API-first messaging platform for businesses to send bulk and personalized messages over SMS, USSD, OTP, and more across Africa.
</p>


      {/* <!-- Buttons --> */}
      <div className="landing-actions mt-8 grid gap-3 w-full sm:inline-flex">
        <a className="inline-flex justify-center items-center gap-x-3 text-center bg-blue-600 hover:bg-blue-800 hover:text-white border border-transparent text-sm lg:text-base text-white font-medium rounded-full focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 focus:ring-offset-white transition py-3 px-5 dark:focus:ring-offset-gray-800" href="https://dashboard.whistlepulse.com/auth/register" target="_blank" rel="noreferrer">
          Get started for free
          <svg className="w-2.5 h-2.5" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M5.27921 2L10.9257 7.64645C11.1209 7.84171 11.1209 8.15829 10.9257 8.35355L5.27921 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </a>
        <a className="inline-flex justify-center items-center gap-x-3.5 text-sm lg:text-base text-center bg-white/80 hover:bg-white shadow-sm font-medium rounded-full focus:outline-none focus:ring-2 transition py-3 px-5 dark:border-gray-800 dark:hover:border-gray-600 dark:shadow-slate-700/[.7] dark:text-white dark:focus:ring-gray-700 dark:focus:ring-offset-gray-800 text-[#221f5b]" href="/contact-us">
          Contact sales team
        </a>
      </div>
      {/* <!-- End Buttons --> */}

      <div className="landing-metrics mt-9 grid gap-3 sm:grid-cols-3">
        {[
          ["300M+", "annual messages"],
          ["99.99%", "delivery rate"],
          ["8K+", "API integrations"],
        ].map(([value, label]) => (
          <div key={label} className="rounded-2xl bg-white/70 p-4 text-left shadow-sm ring-1 ring-blue-100">
            <p className="text-2xl font-black text-[#040051]">{value}</p>
            <p className="mt-1 text-xs font-semibold uppercase tracking-wide text-[#4A487A]">{label}</p>
          </div>
        ))}
      </div>


    </div>
    {/* <!-- End Col --> */}

    <div className="landing-visual relative z-10 mt-10 md:mt-0">
      <div className="landing-visual-frame rounded-3xl bg-white/70 p-3 shadow-2xl shadow-blue-900/10 ring-1 ring-white">
      <img className="rounded-2xl w-full" src={HomepageHeroImage} alt="Whistle Pulse dashboard preview"/>
      </div>
      {/* <div className="absolute inset-0 -z-[1] bg-gradient-to-tr from-gray-200 via-white/0 to-white/0 w-full h-full rounded-md mt-4 -mb-4 mr-4 -ml-4 lg:mt-6 lg:-mb-6 lg:mr-6 lg:-ml-6 dark:from-slate-800 dark:via-slate-900/0 dark:to-slate-900/0"></div> */}

      {/* <!-- SVG--> */}
      <div className="absolute bottom-0 left-0">
 
      </div>
      {/* <!-- End SVG--> */}
    </div>
    {/* <!-- End Col --> */}
  </div>
  {/* <!-- End Grid --> */}
</div>
{/* <!-- End Hero --> */}
    </div>
  )
}

export default HomepageHero
